//DSS Documentation on Validation - http://tiny.sc/cgvalidation
export class User {
    id: number = 0;
    sid: string = '';
    firstName: string = '';
    lastName: string = '';
    emailAddress: string = '';
    username: string = '';
}

